export function zyType(val) {
	let educationname = '';
	if(val==0){
		educationname = '不限';
	}else if(val==1){
		educationname = '高中';
	}else if(val==2){
		educationname = '大专';
	}else if(val==3){
		educationname = '本科';
	}else if(val==4){
		educationname = '硕士';
	}else if(val==5){
		educationname = '博士';
	}
	return educationname;
}

export function experienceType(minyear, maxyear) {
	let text = '';
	if(maxyear>minyear){
		text = minyear+'-'+maxyear+'年';
	}else if(maxyear==0&&minyear==0){
		text = '经验不限';
	}else if(maxyear==0&&minyear>0){
		text = minyear+'年以上';
	}
	return text;
}